<script lang="ts">
	import type { BoundaryCoordinates } from '$lib/components/map/types';
	import SelectionBackground from '$assets/launchpad/selection-masonry.webp';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { POIS_HRT } from '$lib/constants/poilist';
	import { trackLaunchpadClick } from '$lib/services/tracking/googleAnalytics/launchpad';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	const searchParams = getSearchParamsStore();
	const { mapController } = getMapLayoutContext();

	function handleSelectionClick() {
		trackLaunchpadClick('launchpad_discover_selection');
		gotoWithParams('/map', {
			...$searchParams,
			poiCategories: POIS_HRT,
			page: 1,
			filters: { MICHELIN_ACCOMMODATION: true, ONLY_MICHELIN_GUIDE_SELECTION: true },
			bounds: $mapController.getBounds().toArray() as BoundaryCoordinates,
		});
	}
</script>

<section class="flex flex-col items-center justify-center">
	<h3 class="text-center text-balance uppercase text-sm text-coloredneutral-soft font-600 my-0 mb-2 font-smooth">{m.launchpad__selection_title()}</h3>
	<Image src={SelectionBackground} alt={m.launchpad__selection_title()} width="274" height="306" class="w-274px h-306px aspect-ratio-274/306" />
	<Button
		variant="filled"
		color="light"
		size="md"
		icon="recommended"
		iconPosition="right"
		text={m.launchpad__selection_cta_label()}
		class="relative bottom-0 translate-y--6 shadow-smooth-block"
		onclick={handleSelectionClick}
	/>
</section>
